import React from 'react';
import { AboutHero } from './aboutHeroSection';
import { AboutDescription } from './aboutDescription';

export const AboutPage = () => {
  return (
    <main>
        <AboutHero />
        <AboutDescription />
    </main>
  );
};
